import { useQuery } from '@tanstack/react-query';
import { default as addressService } from "../services/address";

export const usePoblacionsINE = (dp: string) => {
  const isReady = !!dp;

  return useQuery({
    queryKey: ['poblacionsINE', dp],
    queryFn: () => addressService.fetchPoblacionsINE(dp || '0'),
    // enabled: isReady,
    staleTime: 1000 * 60 * 30
  })
  
}